// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgBlockMark24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM17.1607 8.61161L8.60532 17.2928C9.55721 17.9724 10.7614 18.3445 12.0881 18.2813C15.3531 18.1259 18.124 15.3938 18.277 12.179C18.3423 10.8067 17.9201 9.56832 17.1607 8.61161ZM5.72618 11.7527C5.87738 8.57557 8.61453 5.87552 11.8398 5.72204C13.2025 5.65719 14.4343 6.0573 15.3911 6.78069L6.91554 15.3847C6.11101 14.4254 5.65919 13.1603 5.72618 11.7527Z"
				/>
			</Svg>
		);
	}
);
SvgBlockMark24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgBlockMark24;
